module.exports = __webpack_public_path__ + "static/img/head-es.f44de235.png";